<template>
  <div>
    <header-admin :active-section="1" />
    <div>
      <div class="float-right">
        <button class="btn btn-primary mt-1" @click="addNewCenter">
          {{ trans("center.addNewCenter") }}
        </button>
      </div>

      <div class="mt-3">
        <ul id="myTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <router-link
              active-class="active"
              class="nav-link"
              to="/admin/centers/active-centers"
            >
              {{ trans("center.activeCenters") }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              active-class="active"
              class="nav-link"
              to="/admin/centers/inactive-centers"
            >
              {{ trans("center.inactiveCenters") }}
            </router-link>
          </li>
        </ul>
      </div>

      <router-view />
    </div>
  </div>
</template>

<script>
import HeaderAdmin from "../../Header.vue";

export default {
  components: {
    HeaderAdmin,
  },
  methods: {
    addNewCenter() {
      this.$router.push({ name: "AdminCentersEdit", params: { id: "new" } });
    },
  },
};
</script>
